import React,{ useState } from 'react';

// ... existing code ...import React, { useState, useRef } from 'react';
import { InputGroup, InputRightElement, IconButton, Box, Text, useDisclosure, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Input } from '@chakra-ui/react';
import { useUpdateUserPasswordMutation } from 'reducers/auth.service';

import { ViewIcon , ViewOffIcon } from '@chakra-ui/icons';
import { errorToast } from 'constants/index';
// change password
const PasswordInput = ({ password , setpassword, label = '' })=>{
    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <InputGroup mb={4}>
            <Input
                placeholder={label}
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setpassword(e.target.value)}
            />
            <InputRightElement>
                <IconButton
                    variant="ghost"
                    size="sm"
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                    onClick={() => setShowPassword(!showPassword)}
                />
            </InputRightElement>
        </InputGroup>
    );
};
export default function ChangeUserPassword({ data , refetch }) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [updatePassowrd] = useUpdateUserPasswordMutation();

    const { isOpen: isModalOpen, onOpen: onModalOpen, onClose: onModalClose } = useDisclosure();
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (newPassword === confirmPassword) {
            onModalClose();
            updatePassowrd({ id: data?._id , USERTYPE: data?.userType , body: { newPassword } }).unwrap().then((response)=>{
                refetch();
            });
        } else {
            errorToast('New Password and confirm password should be same!');
        }
    };

    return (
        <div>
            <Modal isOpen={isModalOpen} onClose={onModalClose}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={handleSubmit}>
                        <ModalHeader>Change Password</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <Text mb={4}>Here you can change the password for the user.</Text>
                            <PasswordInput label={'New Password' } password={newPassword} setpassword={setNewPassword}/>
                            <PasswordInput label={'Confirm New Password'} password={confirmPassword} setpassword={setConfirmPassword}/>

                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="blue" onClick={onModalClose}>
                                            Close
                            </Button>
                            <Button colorScheme="blue" type='submit' ml={3}>
                               Save
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
            <Box display="flex" justifyContent="space-between" w="full">
                <Text fontWeight="bold">Change User Password</Text>

                <Button onClick={onModalOpen} color="teal.500" display="flex" alignItems="center" fontSize="sm">
                                        Change Password
                </Button>
            </Box>

        </div>
    );
}
